export default "__VITE_ASSET__9c6e5840__"